import { api } from '@/lib/api'
import { StatusAtendimento } from '../constants/statusAtendimento'


/**
 * Busca o último status do atendimento (que não seja "Novo")
 */
export const getLatestAtendimentoStatus = async (
  atendimentoId: number | undefined
): Promise<StatusAtendimento | null> => {
  if (!atendimentoId) {
    return null
  }

  try {
    const response = await api.get(`/api/atendimentos/${atendimentoId}`)
    const atendimento = response.result

    if (atendimento?.status_atendimento) {
      const status = atendimento.status_atendimento as string
      // Retorna null se for "Novo", caso contrário retorna o status
      return status === StatusAtendimento.NOVO
        ? null
        : (status as StatusAtendimento)
    }

    return null
  } catch (error) {
    console.error('Erro ao buscar status do atendimento:', error)
    return null
  }
}
